import { paragraphSpec as e } from "./nodes/paragraph-spec.js";
import { smallSpec as t } from "./nodes/small-spec.js";
import { headingSpec as n, subheading3Spec as r, subheading4Spec as i, subheadingSpec as a } from "./nodes/heading-spec.js";
import { calloutSpec as o } from "./nodes/callout-spec.js";
import { codeBlockSpec as s } from "./nodes/code-block-spec.js";
import { videoFileSpec as c } from "./nodes/video-file-spec.js";
import { audioFileSpec as l } from "./nodes/audio-file-spec.js";
import { imageSpec as u } from "./nodes/image-spec.js";
import { videoSpec as d } from "./nodes/video-spec.js";
import { buttonSpec as f } from "./nodes/button-spec.js";
import { tableCellSpec as p, tableRowSpec as m, tableSpec as h } from "./nodes/table-spec.js";
import { listItemSpec as g, nestedListItemSpec as _, orderedListSpec as v, orderedNestedListSpec as y, unorderedListSpec as b, unorderedNestedListSpec as x } from "./nodes/list-spec.js";
import { hardBreakSpec as S } from "./nodes/hard-break-spec.js";
import { templateSpec as C } from "./nodes/template-spec.js";
import { mentionSpec as w } from "./nodes/mention-spec.js";
import { aiPromptDataSpec as T } from "./nodes/ai-prompt-data-spec.js";
import { htmlSpec as E } from "./nodes/html-spec.js";
import { horizontalRuleSpec as D } from "./nodes/horizontal-rule-spec.js";
import { ifElseStatementSpec as O } from "./nodes/if-else-statement-spec.js";
import { messengerCardSpec as k } from "./nodes/messenger-card-spec.js";
import { markerSpec as A } from "./nodes/marker-spec.js";
import { placeholderSpec as j } from "./nodes/placeholder-spec.js";
import { twitterFollowButtonSpec as M } from "./nodes/twitter-follow-button-spec.js";
import { facebookLikeButtonSpec as N } from "./nodes/facebook-like-button-spec.js";
import { socialSpec as P } from "./nodes/social-spec.js";
import { spacerSpec as F } from "./nodes/spacer-spec.js";
import { collapsibleSectionContentSpec as I, collapsibleSectionSpec as L, collapsibleSectionSummarySpec as R } from "./nodes/collapsible-section-spec.js";
import { inlineImageSpec as z } from "./nodes/inline-image-spec.js";
import { unsupportedElementSpec as B } from "./nodes/unsupported-element-spec.js";
import { imageTextSpec as V } from "./nodes/image-text-spec.js";
//#region src/specs/node-specs.ts
var H = {
	doc: { content: "(block | list | table)+" },
	singleBlockDoc: { content: "(block | list | table)" },
	text: { group: "inline" },
	paragraph: e,
	hardBreak: S,
	template: C,
	mention: w,
	aiPromptData: T,
	html: E,
	horizontalRule: D,
	orderedList: v,
	unorderedList: b,
	listItem: g,
	heading: n,
	subheading: a,
	subheading3: r,
	subheading4: i,
	small: t,
	codeBlock: s,
	ifElseStatement: O,
	image: u,
	inlineImage: z,
	videoFile: c,
	audioFile: l,
	video: d,
	button: f,
	messengerCard: k,
	marker: A,
	table: h,
	tableRow: m,
	tableCell: p,
	orderedNestedList: y,
	unorderedNestedList: x,
	nestedListItem: _,
	placeholder: j,
	twitterFollowButton: M,
	facebookLikeButton: N,
	social: P,
	spacer: F,
	callout: o,
	collapsibleSection: L,
	collapsibleSectionSummary: R,
	collapsibleSectionContent: I,
	unsupportedElement: B,
	imageText: V
};
//#endregion
export { H as nodeSpecs };
